export class FetchAllListCount {
  static readonly type = '[FetchAllListCount] Post';
}
